import {NgModule} from '@angular/core';

import {ContrastDirective} from './contrast.directive';

@NgModule({
  declarations: [ContrastDirective],
  exports: [ContrastDirective],
})
export class ContrastModule {}
